module.exports = __webpack_public_path__ + "img/song-tea_thumbnail.da713737.jpg";